<h1 mat-dialog-title>Untersuchung editieren</h1>
<div mat-dialog-content>
    <mat-form-field>
        <mat-label>Untersuchung</mat-label>
        <input matInput type="text" [formControl]="valueCtrl" />
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()">Editieren</button>
</div>
